import { HStack, Stack } from "@chakra-ui/react-v3";

import { Skeleton, SkeletonText } from "./Skeleton";

export type CardSkeletonProps = {
  /** Number of body text lines. */
  lines?: number;
  /** Reserve a button-sized placeholder at the end of the title bar. */
  headerAction?: boolean;
  /** Reserve a button-sized placeholder below the body. */
  footerAction?: boolean;
};

/**
 * Placeholder for one card: a title bar, body lines, and optional header and
 * footer actions, on the same surface, padding, and radius as BasicCard. It
 * renders a single card; the caller supplies the grid or stack and repeats it.
 */
export function CardSkeleton(props: CardSkeletonProps) {
  const { lines = 3, headerAction = false, footerAction = false } = props;

  return (
    <Stack
      gap="6"
      p="6"
      bg="bg.container"
      border="1px solid"
      borderColor="border.divider"
      borderRadius="2xl"
    >
      <HStack justify="space-between" gap="4">
        <Skeleton height="6" width="40" />
        {headerAction && <Skeleton height="8" width="20" />}
      </HStack>
      {lines > 0 && <SkeletonText noOfLines={lines} gap="2" />}
      {footerAction && <Skeleton height="8" width="24" />}
    </Stack>
  );
}
